import React from 'react'
import './Menu.component.css'

class Menu extends React.Component {
  render() {
    return ( 
      <div className='menu'>
          <h1>DAIRY APP</h1>
          <p>Comment with no sense</p>
      </div>
    )
  }
}
export default Menu



